export default __webpack_public_path__ + "static/media/Bhatnagar.7ab60284.png";